
{
  "familyId": "GET-GROOT-VERGELIJK",
  "questions": [
    {
      "id": "GET-GROOT-VERGELIJK-001",
      "familyId": "GET-GROOT-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "skill": "positiestelsel",
      "subSkill": "groot_vergelijken",
      "questionType": "multiple_choice",
      "question": "Welk getal is het grootst?",
      "context": null,
      "options": ["567", "576", "657", "675"],
      "correctAnswer": 3,
      "conceptId": "compare_three_digit",
      "variantIndex": 1,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.65,
      "group": 6,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Getallen vergelijken",
            "content": "Vergelijk cijfer voor cijfer van links naar rechts: honderdtallen eerst, dan tientallen, dan eenheden."
          }
        }
      ],
      "feedback": {
        "explanationText": "Vergelijk cijfer voor cijfer van links naar rechts (plaatswaarde). Stap 1: honderdtallen: 5, 5, 6, 6 → 657 en 675 zijn het grootst (honderdtal 6 > 5). Stap 2: tientallen van 657 en 675: 5 vs 7 → 7 > 5, dus 675 > 657. Antwoord: 675.",
        "distractorExplanations": {
          "0": "567 is niet het grootst. Het honderdtal is 5, maar 657 en 675 hebben honderdtal 6 — die zijn groter.",
          "1": "576 is niet het grootst. Het honderdtal is ook 5. De getallen met honderdtal 6 (657 en 675) zijn groter.",
          "2": "657 is groter dan 567 en 576, maar niet het grootst. Vergelijk met 675: tientalcijfer 5 < 7, dus 675 > 657.",
          "3": "Goed! 675 heeft honderdtal 6 (grootste) en tientalcijfer 7 (groter dan 5 van 657). Dus 675 is het grootst."
        }
      }
    },
    {
      "id": "GET-GROOT-VERGELIJK-002",
      "familyId": "GET-GROOT-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "skill": "positiestelsel",
      "subSkill": "groot_vergelijken",
      "questionType": "multiple_choice",
      "question": "Welk getal is het kleinst?",
      "context": null,
      "options": ["234", "243", "324", "342"],
      "correctAnswer": 0,
      "conceptId": "compare_smallest",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.62,
      "group": 6,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kleinste getal vinden",
            "content": "Vergelijk de honderdtallen eerst. Het kleinste honderdtal geeft het kleinste getal."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is 234. Vergelijk de honderdtallen: 2, 2, 3, 3. De getallen met honderdtal 2 zijn het kleinst (234 en 243). Vergelijk dan de tientallen: 3 en 4. Omdat 3 < 4, is 234 het kleinst.",
        "distractorExplanations": {
          "0": "Goed! 234 heeft honderdtal 2 en tientalcijfer 3 — het kleinste van alle vier.",
          "1": "243 heeft ook honderdtal 2, maar tientalcijfer 4 > 3. Dus 243 > 234. Niet het kleinst.",
          "2": "324 heeft honderdtal 3. Dat is groter dan honderdtal 2 van 234 en 243. Dus 324 is niet het kleinst.",
          "3": "342 heeft ook honderdtal 3, groter dan 2. Bovendien is het tientalcijfer 4 > 2 van 324. 342 is het grootst van de vier."
        }
      }
    },
    {
      "id": "GET-GROOT-VERGELIJK-003",
      "familyId": "GET-GROOT-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "skill": "positiestelsel",
      "subSkill": "groot_vergelijken",
      "questionType": "multiple_choice",
      "question": "Zet deze getallen van klein naar groot: 89, 98, 809, 890",
      "context": null,
      "options": [
        "89 - 98 - 809 - 890",
        "89 - 98 - 890 - 809",
        "98 - 89 - 809 - 890",
        "809 - 890 - 89 - 98"
      ],
      "correctAnswer": 0,
      "conceptId": "order_mixed_digits",
      "variantIndex": 3,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.68,
      "group": 6,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Getallen ordenen",
            "content": "Meer cijfers = groter getal. 3-cijferige getallen zijn altijd groter dan 2-cijferige getallen."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is 89 - 98 - 809 - 890. Stap 1: 2-cijferige getallen (89, 98) zijn kleiner dan 3-cijferige getallen (809, 890). Stap 2: van de 2-cijferige: 89 < 98. Stap 3: van de 3-cijferige: 809 < 890.",
        "distractorExplanations": {
          "0": "Goed! 89 < 98 (2-cijferig), dan 809 < 890 (3-cijferig).",
          "1": "Fout: 890 en 809 staan omgewisseld. 809 < 890 omdat het tientalcijfer 0 < 9. De volgorde moet zijn: 809 vóór 890.",
          "2": "Fout: 98 en 89 staan omgewisseld. 89 < 98 omdat het tientalcijfer 8 < 9. De volgorde moet zijn: 89 vóór 98.",
          "3": "Fout: de 3-cijferige getallen staan vóór de 2-cijferige. Maar 2-cijferige getallen (89, 98) zijn altijd kleiner dan 3-cijferige getallen (809, 890)."
        }
      }
    },
    {
      "id": "GET-GROOT-VERGELIJK-004",
      "familyId": "GET-GROOT-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "skill": "positiestelsel",
      "subSkill": "groot_vergelijken",
      "questionType": "multiple_choice",
      "question": "Welk teken hoort tussen deze getallen? 1.234 ... 1.243",
      "context": null,
      "options": ["<", ">", "=", "≠"],
      "correctAnswer": 0,
      "conceptId": "compare_symbols",
      "variantIndex": 4,
      "citoDifficulty": 0.4,
      "citoDiscrimination": 0.7,
      "group": 6,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vergelijkingstekens",
            "content": "< betekent 'kleiner dan'. > betekent 'groter dan'. = betekent 'gelijk aan'."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is <. Vergelijk 1.234 en 1.243: de duizendtallen (1) en honderdtallen (2) zijn gelijk. Vergelijk de tientallen: 3 < 4. Dus 1.234 < 1.243.",
        "distractorExplanations": {
          "0": "Goed! Tientalcijfer 3 < 4, dus 1.234 < 1.243.",
          "1": "> betekent 'groter dan'. Maar 1.234 is kleiner dan 1.243 (tientalcijfer 3 < 4). Het teken moet omgedraaid: 1.234 < 1.243.",
          "2": "= betekent 'gelijk aan'. Maar 1.234 ≠ 1.243 — ze verschillen in het tientalcijfer (3 vs 4). Ze zijn niet gelijk.",
          "3": "≠ betekent 'ongelijk aan'. Hoewel ze inderdaad ongelijk zijn, vraagt de opgave welk vergelijkingsteken past. Het juiste teken is < (kleiner dan), niet ≠."
        }
      }
    }
  ]
}
